import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/material.module';

export interface ConcluirAtencionDialogData {
  nombre: string;
  numeroTurno: string;
}

@Component({
  selector: 'app-concluir-atencion-dialog',
  standalone: true,
  imports: [CommonModule, MaterialModule, MatDialogModule],
  template: `
    <h2 mat-dialog-title>Concluir atención</h2>
    <mat-dialog-content>
      <p>¿Concluir la atención del turno <strong>{{ data.numeroTurno }}</strong>?</p>
      <p class="text-muted">{{ data.nombre }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="cerrar(false)">Cancelar</button>
      <button mat-flat-button color="primary" type="button" (click)="cerrar(true)">Concluir</button>
    </mat-dialog-actions>
  `,
  styles: [`
    .text-muted { opacity: 0.75; margin-top: 8px; }
  `],
})
export class ConcluirAtencionDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<ConcluirAtencionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConcluirAtencionDialogData,
  ) {}

  /** Cierra el diálogo con resultado */
  cerrar(confirmar: boolean): void {
    this.dialogRef.close(confirmar);
  }
}
